import { ActionsCell } from "../../../Component/Common/Components/DataTable/ActionsCell";
import { DefaultCell } from "../../../Component/Common/Components/DataTable/DefaultCell";
import { BEEGeneratedCertificate } from "../../../Component/Model/Dto/VerificationAgency/VerificationAgencyClient";
import { DateFormatter } from "../../../Component/Model/helpers";
import { ActionType, TableColumn } from "../../../Component/Model/Table/Table";

interface CertificateRows {
    Id: string;
    CertificateType: string;
    IssueDate: string;
    ComplianceLevel: string
    Username: string;
    CertificateNumber: string;
    VersionNumber: string;
    Actions: ActionType[];
}
  
  interface CertificateTable {
    columns: Array<TableColumn>;
    rows: Array<CertificateRows>;
}
  
export function VAClientCertificateTableMapper(dataObject: BEEGeneratedCertificate.Dto[] , deleteCertificate : (id:string) => void, downloadCertificate : (id:string) => void): CertificateTable {
    const columns = [
       
        { Header: 'Type', accessor: 'CertificateType', id:'CertificateTypeEnumId', Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true}/> },
        { Header: 'Certificate Issue Date', accessor: 'IssueDate', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'B-BBEE Recognition Level', accessor: 'ComplianceLevel', id: 'ComplianceLevelEnumId', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Username', accessor: 'Username', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Certificate Number', accessor: 'CertificateNumber', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Version Number', accessor: 'VersionNumber', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Actions', accessor: 'Actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true }
    ];
    if (dataObject.length > 0) {
        const rows = dataObject.map((item: BEEGeneratedCertificate.Dto, index: number) => ({
            Id: item.id,
            CertificateType: item.certificateType,
            IssueDate: DateFormatter(item.issueDate.toString()),
            ComplianceLevel: item.complianceLevel,
            Username: item.username,
            CertificateNumber: item.certificateNumber,
            VersionNumber: item.versionNumber,
            Actions: [
                {
                    key: index.toString(),
                    label: 'Download',
                    action: () => {
                        downloadCertificate(item.id);
                    },
                    icon: {
                        color: 'secondary',
                        name: 'download'
                    }
                },
                {
                    key: index.toString(),
                    label: 'Delete',
                    action: () => {
                        deleteCertificate(item.id);
                    },
                    icon: {
                        color: 'error',
                        name: 'delete'
                    }
                }
            ]

        }));
        return { columns: columns, rows: rows };
    }
    else{
        return { columns: columns, rows: [] };
    }
}